import styled from 'styled-components';

export const StyledRocketContainer = styled.div`
  width: 30%;
  height: 70vh;
  padding: 1.75rem 0 0 0;
  margin-top: 6.54rem;
  @media (max-width: 768px) {
    width: 20%;
    height: auto;
    margin-top: 0;
    padding: 0;
  }
`;

export const StyledRocketImage = styled.img`
  width: 100%;
`;
